import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"

const useStyles = makeStyles(() => ({
	editorContainer: {
		border: `1px solid ${colors.gray[200]}`,
		borderRadius: 12,
		padding: 16,
		width: "100%"
	},
	editableSentence: {
		display: "block",
		fontSize: "14.5px",
		lineHeight: 2,
		color: colors.gray[900],
		marginTop: 4,
		width: "100%"
	},
	inlineSelect: {
		display: "inline-flex",
		borderBottom: `2px solid ${colors.blue[300]}`,
		backgroundColor: "transparent",
		color: colors.blue[800],
		fontWeight: 800,
		fontSize: "14.5px",
		padding: 2,
		margin: "0 3px",
		cursor: "pointer",
		"&:before": {
			borderBottom: "none"
		},
		"&:after": {
			borderBottom: "none"
		},
		"& .MuiSelect-select": {
			padding: "2px 32px 2px 2px",
			fontWeight: 800,
			color: colors.blue[800],
			fontSize: "14.5px"
		}
	},
	callout: {
		backgroundColor: colors.purple[50],
		borderRadius: 12,
		padding: "14px 16px",
		display: "flex",
		alignItems: "flex-start",
		gap: 12,
		marginTop: 20
	},
	calloutIconContainer: {
		width: 28,
		height: 28,
		borderRadius: 8,
		backgroundColor: colors.purple[100],
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
		flexShrink: 0
	},
	calloutText: {
		fontSize: "13.5px",
		lineHeight: 1.5,
		color: colors.purple[900]
	}
}))

export default useStyles
